import { StaffForm } from '../../organization_structure/personal_information_management'
import { Row, Form, Col, DatePicker, Input } from './../../ui/ot'
import { useTranslation } from "react-i18next"

const NaturePersonFormItems = ({
    formValues,
    propsCustomForm,
    field,
    fieldName = field?.name,
    propsOnFinish,
    keyPrefix,
    propsShowKeys = [
        { key: "task_id", name: "task_id", hidden: false, require: false },
        { key: "start_time", name: "start_time", hidden: true, require: false },
        { key: "row_number_partition_date_order_task_id", name: "row_number_partition_date_order_task_id", hidden: false, require: false },
        { key: "staff_id", name: "staff_id", hidden: false, require: false },
        { key: "serial_name", name: "serial_name", hidden: false, require: false },
        { key: "user_department_role_data", name: "user_department_role_data", hidden: false, require: false },
        { key: "staff_name", name: "staff_name", hidden: false, require: false },
        { key: "birthday", name: "birthday", hidden: false, require: false },
        { key: "lunar_birthday", name: "lunar_birthday", hidden: false, require: false },
        { key: "staff_phone", name: "staff_phone", hidden: false, require: false },
        { key: "address", name: "address", hidden: false, require: false },
        { key: "email", name: "email", hidden: false, require: false },
        { key: "task_name", name: "task_name", hidden: false, require: false },
        { key: "staff_serial_name", name: "staff_serial_name", hidden: false, require: false, },
        { key: "staff_english_name", name: "staff_english_name", hidden: true, require: false, },
        { key: "user_department_role_data", name: "user_department_role_data", hidden: false, require: false, },
        { key: "email", name: "email", hidden: false, require: false, },
        { key: "custom_line_id", name: "custom_line_id", hidden: true, require: false, },
        { key: "address", name: "address", hidden: false, require: false, },
        { key: "staff_phone", name: "staff_phone", hidden: false, require: false, },
        { key: "property_json", name: "property_json", hidden: false, require: false, },
        { key: "auto_in_card_machine", name: "auto_in_card_machine", hidden: true, require: false, },
    ],
    formOnValuesChange,
    departmentMode,
}) => {
    const { t } = useTranslation('translation', { keyPrefix })
    const currentKey = propsShowKeys

    return <>
        <Row>
            <Form.Item
                hidden
                name={[fieldName, 'natural_person_task_data', 0, 'natural_person_area_data']}
            >
            </Form.Item>
            <Col span={24}
                hidden={currentKey?.find((element) => {
                    return element.name === "begin_time"
                })?.hidden}
            >
                <Form.Item
                    label={t('start_time')}
                    name={[fieldName, 'start_time']}
                    rules={[
                        {
                            required: currentKey?.find((element) => {
                                return element.name === "begin_time"
                            })?.require,
                            message: "請輸入"
                        }
                    ]}
                    labelCol={{ xs: 24, md: 8 }}
                    wrapperCol={{ xs: 24, md: 16 }}
                >
                    <DatePicker.Time />
                </Form.Item>
            </Col>
            <Col span={24}
                hidden={currentKey?.find((element) => {
                    return element.name === "number"
                })?.hidden}
            >
                <Form.Item
                    label={t('number')}
                    name={[fieldName, 'natural_person_task_data', 0, 'number']}
                    rules={[
                        {
                            required: currentKey?.find((element) => {
                                return element.name === "number"
                            })?.require,
                            message: "請輸入"
                        }
                    ]}
                >
                    <label>自動產生</label>
                </Form.Item >
            </Col>
        </Row>

        {/* 人員基本資料 start */}
        <Row>
            <Col span={24}
            >
                <Form.List
                    name={[field?.name, 'natural_person_task_data', 0, 'natural_person_staff_data']}
                >
                    {fields => <>
                        {fields?.map(subField => <>
                            <StaffForm
                                propsForm={propsCustomForm}
                                onFormFinish={propsOnFinish}
                                field={subField}
                                propsShowKeys={propsShowKeys}
                                customFormItems={(fieldName, formValues, onValuesChange, propsCustomForm, field, propsOnValueChange, onFormFinish) => {
                                    return <>
                                        {/* <Row>
                                            <Col span={24}
                                                hidden={currentKey?.find((element) => {
                                                    return element.name === "birthday"
                                                })?.hidden}
                                            >
                                                <Form.Item
                                                    label={t('birthday')}
                                                    name={[field?.name ?? '', "birthday"]}
                                                    rules={[
                                                        {
                                                            required: currentKey?.find((element) => {
                                                                return element.name === "birthday"
                                                            })?.require,
                                                            message: "請輸入"
                                                        }
                                                    ]}
                                                >
                                                    <DatePicker.Time />
                                                </Form.Item>
                                            </Col>
                                            <Col span={24}
                                                hidden={currentKey?.find((element) => {
                                                    return element.name === "lunar_birthday"
                                                })?.hidden}
                                            >
                                                <Form.Item
                                                    label={t('birthday_lunar')}
                                                    name={[field?.name ?? '', "lunar_birthday"]}
                                                    rules={[
                                                        {
                                                            required: currentKey?.find((element) => {
                                                                return element.name === "lunar_birthday"
                                                            })?.require,
                                                            message: "請輸入"
                                                        }
                                                    ]}
                                                >
                                                    <DatePicker.Time />
                                                </Form.Item>
                                            </Col>
                                        </Row> */}
                                    </>
                                }}
                                genderOption="radio"
                                formMode
                                formOnValuesChange={formOnValuesChange}
                                departmentMode={departmentMode}
                            />
                        </>)}
                    </>}
                </Form.List>
            </Col>
            <Col span={24}
                hidden={currentKey?.find((element) => {
                    return element.name === "task_name"
                })?.hidden}
            >
                <Form.Item
                    label={t('task_name')}
                    name={[fieldName, 'task_name']}
                    rules={[
                        {
                            required: currentKey?.find((element) => {
                                return element.name === "task_name"
                            })?.require,
                            message: "請輸入"
                        }
                    ]}
                >
                    <Input />
                </Form.Item>
            </Col>
        </Row>
    </>
}
export default NaturePersonFormItems 